import { SEARCH_RESULT_BOOSTED_VIEW_ROUTE } from '@/modules/activityTracker/constants';

export function getProductViewTransitionFrom(
  referer: string,
  isBoostedView: boolean
) {
  return isBoostedView ? SEARCH_RESULT_BOOSTED_VIEW_ROUTE : referer;
}
